
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Merchant Registration Requests</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Merchant Registration Requests</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWMerchantRegistrationRequest">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWMerchantRegistrationRequestList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">


            <div class="form-group required" >
              <label class="control-label">First Name</label>
              <input type="text" id="first_name" name="first_name"
                     v-bind:class="{'has-error' : errors.has('first_name')}"
                     v-validate="'required'"
                     v-model="value.first_name" class="form-control first_name"
                     placeholder="First Name" readonly>
              <div class="help text-danger" v-show="errors.has('first_name')">
                {{ errors.first("first_name") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Email</label>
              <input type="text" id="email" name="email"


                     v-model="value.email" class="form-control email"
                     placeholder="Email" readonly>

            </div>
            <div class="form-group required" >
              <label class="control-label">Gender</label>
              <select class="form-control" style="width: 100%;" v-bind:class="{'has-error' : errors.has('gender')}"
                      v-validate="'required'" name="gender" v-model="value.gender" id="gender" disabled>
                <option value="male">male</option><option value="female">female</option><option value="other">other</option>
              </select>
              <div class="help text-danger" v-show="errors.has('gender')">
                {{ errors.first("gender") }}
              </div>
            </div>
            <div class="form-group required" >
                <label class="control-label">Date of Birth</label>
                <div class="clearfix"></div>
                <el-date-picker
                    v-model="value.date_of_birth"
                    type="date"
                    placeholder="Select date"
                    id="date_of_birth"
                    name="date_of_birth"
                    class="d-block date_of_birth"
                    v-bind:class="{'has-error' : errors.has('date_of_birth')}"
                    v-validate="'required'"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    disabled
                >
                </el-date-picker>
              <div class="help text-danger" v-show="errors.has('date_of_birth')">
                {{ errors.first("date_of_birth") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Id Card/Passport Number</label>
              <input type="text" id="id_card_number" name="id_card_number"


                     v-model="value.id_card_number" class="form-control id_card_number"
                     placeholder="Id Card/Passport Number" readonly>

            </div>
                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Id Card Picture</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="id_card_picture"></label>
                        <div class="row align-items-center">
                          <div v-if="!value.id_card_picture" class="col-12">
                            <div class="alert alert-warning">No data</div>
                          </div>
                          <div v-else class="col-4">
                            <img v-bind:src="getImageUrl(value.id_card_picture)" class="img-fluid img-thumbnail rounded" style="width: 200px;" alt="test">
                          </div>


                        </div>
                    </div>

            <div class="form-group required" >
              <label class="control-label">Shop Name</label>
              <input type="text" id="shop_name" name="shop_name"
                     v-bind:class="{'has-error' : errors.has('shop_name')}"
                     v-validate="'required'"
                     v-model="value.shop_name" class="form-control shop_name"
                     placeholder="Shop Name" readonly>
              <div class="help text-danger" v-show="errors.has('shop_name')">
                {{ errors.first("shop_name") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Corporate Id</label>
              <input type="text" id="corporate_id" name="corporate_id"


                     v-model="value.corporate_id" class="form-control corporate_id"
                     placeholder="Corporate Id" readonly>

            </div>
            <div class="form-group " >
              <label class="control-label">Corporate Name</label>
              <input type="text" id="corporate_name" name="corporate_name"


                     v-model="value.corporate_name" class="form-control corporate_name"
                     placeholder="Corporate Name" readonly>

            </div>
            <div class="form-group required" >
              <label class="control-label">Country</label>
              <input type="text" id="country" name="country"
                     v-bind:class="{'has-error' : errors.has('country')}"
                     v-validate="'required'"
                     v-model="value.country_id" class="form-control country"
                     placeholder="Country" readonly>
              <div class="help text-danger" v-show="errors.has('country')">
                {{ errors.first("country") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Province</label>
              <input type="text" id="province" name="province"
                     v-bind:class="{'has-error' : errors.has('province')}"
                     v-validate="'required'"
                     v-model="value.city_id" class="form-control province"
                     placeholder="Province" readonly>
              <div class="help text-danger" v-show="errors.has('province')">
                {{ errors.first("province") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Address</label>
              <input type="text" id="address" name="address"


                     v-model="value.address" class="form-control address"
                     placeholder="Address" readonly>

            </div>
            <div class="form-group " >
              <label class="control-label">contact_number</label>
              <input type="text" id="contact_number" name="contact_number"


                     v-model="value.contact_number" class="form-control contact_number"
                     placeholder="contact_number" readonly>

            </div>
                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Shop Image</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="shop_image"></label>
                        <div class="row align-items-center">
                          <div v-if="!value.shop_image" class="col-12">
                            <div class="alert alert-warning">No data</div>
                          </div>
                          <div v-else class="col-4">
                            <img v-bind:src="getImageUrl(value.shop_image)" class="img-fluid img-thumbnail rounded" style="width: 200px;" alt="test">
                          </div>
                          <div class="help text-danger" v-show="errors.has('shop_image')">
                {{ errors.first("shop_image") }}
              </div>
                        </div>
                    </div>

                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Shop Certificate Image</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="shop_certificate_image"></label>
                        <div class="row align-items-center">
                          <div v-if="!value.shop_certificate_image" class="col-12">
                            <div class="alert alert-warning">No data</div>
                          </div>
                          <div v-else class="col-4">
                            <img v-bind:src="getImageUrl(value.shop_certificate_image)" class="img-fluid img-thumbnail rounded" style="width: 200px;" alt="test">
                          </div>

                        </div>
                    </div>

                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Shop Logo Image</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="shop_logo_image"></label>
                        <div class="row align-items-center">
                          <div v-if="!value.shop_logo_image" class="col-12">
                            <div class="alert alert-warning">No data</div>
                          </div>
                          <div v-else class="col-4">
                            <img v-bind:src="getImageUrl(value.shop_logo_image)" class="img-fluid img-thumbnail rounded" style="width: 200px;" alt="test">
                          </div>

                        </div>
                    </div>

            <div class="form-group " >
              <label class="control-label">Previous User Id</label>
              <input type="text" id="previous_user_id" name="previous_user_id"


                     v-model="value.previous_user_id" class="form-control previous_user_id"
                     placeholder="Previous User Id" readonly>

            </div>
            <div class="form-group required" v-show="false">
              <label class="control-label">Password</label>
              <input type="text" id="password" name="password"
                     v-bind:class="{'has-error' : errors.has('password')}"
                     v-validate="'required'"
                     v-model="value.password" class="form-control password"
                     placeholder="Password" >
              <div class="help text-danger" v-show="errors.has('password')">
                {{ errors.first("password") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Status</label>
              <select class="form-control" style="width: 100%;" v-bind:class="{'has-error' : errors.has('status')}"
                      v-validate="'required'" name="status" v-model="value.status" id="status">
                <option value="Approved">Approved</option><option value="Reject">Reject</option>
              </select>
              <div class="help text-danger" v-show="errors.has('status')">
                {{ errors.first("status") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWMerchantRegistrationRequestForm',
  metaInfo: {
    title: 'EW Merchant Registration Request | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
        id_card_picture: '',
        shop_image: '',
        shop_certificate_image: '',
        shop_logo_image: '',
        country_id:null,
        city_id:null
    },
    pre: {

    }
  }),
  methods: {
    getImageUrl(shopImage) {
      return this.API_ASSET_UPLOAD_URL + shopImage;
    },

    handleSubmission () {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_merchant_registration_requests'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_merchant_registration_requests/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWMerchantRegistrationRequestList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_merchant_registration_requests/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })

      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

